<template>
  <div
    :class="[`tdx-dropdown-item--${size}`, disabled ? 'txt--grey' : '']"
    class="tdx-dropdown-item"
  >
    <div
      v-if="option.logo"
      class="tdx-dropdown-item__icon"
    >
      <tdx-ticker-logo
        :src="option.logo"
        :alt="option.name || option.label || option.ticker"
        :size="tickerLogoSize"
        :transparent-border="logoWithoutBorder"
      />
    </div>
    <span class="tdx-dropdown-item__text">
      {{ option.ticker || option.name || option.label }}
    </span>
  </div>
</template>
<script>
import { defaultSize, sizeValidator, getPreviousUiKitSize } from '@/lib/utils'
import TdxTickerLogo from '@/components/common/ticker/TdxTickerLogo.vue'

export default {
  name: 'DropdownItem',
  components: {
    TdxTickerLogo,
  },
  props: {
    option: {
      type: Object,
      required: true,
    },
    size: {
      validator: sizeValidator,
      default: defaultSize,
    },
    disabled: { type: Boolean, default: false },
    logoWithoutBorder: { type: Boolean, default: false },
  },
  computed: {
    tickerLogoSize () {
      return getPreviousUiKitSize(this.size)
    },
  },
}
</script>
<style lang="scss" scoped>
.tdx-dropdown-item {
  $root: &;

  display: flex;
  align-items: center;
  overflow: hidden;

  &__icon {
    margin-right: toRem(7px);
  }

  &__text {
    line-height: toRem(16px);
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @each $name, $val in $uiKitSizes {
    &--#{$name} {
      height: toRem($val);
      // padding: 0 toRem($val / 3);
    }
  };
}
</style>
